import { gql } from '@apollo/client';

export const AppFragment = gql`
  fragment AppFragment on App {
    id
    name
    image
    internalAppId
    brand {
      hashedId
      name
    }
  }
`;
